module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "pFrontCover"
    }
  }), _c('a', {
    attrs: {
      "id": "pFrontFlap"
    }
  }), _c('a', {
    attrs: {
      "id": "pEndpapers"
    }
  }), _c('a', {
    attrs: {
      "id": "pi"
    }
  }), _c('a', {
    attrs: {
      "id": "pii"
    }
  }), _c('a', {
    attrs: {
      "id": "piii"
    }
  }), _c('a', {
    attrs: {
      "id": "piv"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_c('p', {
    staticClass: "left "
  }, [_vm._v("First Mariner Books edition 2013")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_c('a', {
    attrs: {
      "id": "px0"
    }
  }), _vm._v("Copyright © 2012 by Wael Ghonim")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_vm._v("For information about permission to reproduce selections from this book, write to "), _c('a', {
    attrs: {
      "href": "mailto:trade.permissions@hmhco.com"
    }
  }, [_vm._v("trade.permissions@hmhco.com")]), _vm._v(" or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.")]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_c('a', {
    attrs: {
      "href": "https://hmhbooks.com/",
      "target": "_blank"
    }
  }, [_vm._v("hmhbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_c('em', [_vm._v("The Library of Congress has cataloged the print edition as follows:")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Ghonim, Wael, date."), _c('br'), _vm._v("\nRevolution 2.0: the power of the people is greater than the people in power : a memoir / Wael Ghonim."), _c('br'), _vm._v("\np. cm."), _c('br'), _vm._v("\nIncludes index.")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-547-77398-8")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-547-86709-0")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("1. Ghonim, Wael, date. 2. Political activists—Egypt. 3. Internet—Political aspects—Egypt. 4. Egypt—History—1981–")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("I. Title. II. Title: Memoir and call to action.")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DT")]), _vm._v("107.828."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("G")]), _vm._v("445"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v("3 2012"), _c('br'), _vm._v("\n962.05'5092—dc23"), _c('br'), _vm._v("\n[B]  2011042557")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Cover design by Brian Moore")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Cover photograph © Khalil Hamra / AP")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Author portrait by Sam Christmas")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Frontispiece photograph © Khaled Desouki / Getty Images")]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_vm._v("e"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-547-77404-6"), _c('br'), _vm._v("\nv5.0621")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-133015e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 60
// module chunks = 0